/*
  组合筛选器配置
  label: 字段名称
  value: 字段值，用于映射子组件
  supportOperators: 支持的操作符
  opLabel: 操作符文字描述
  isCombined: 操作符和值是否组合, 处理左边填写操作符右面填写数值的组件
  labelPath: 子组件的label路径
  isArray: 子组件是否是级联多选
  isTime: 子组件是否是时间选择，处理日期区间的组件
  isDuration: 子组件是否是时长选择，处理时长区间的组件
*/

interface OptionConfig {
  label: string
  value: string
  supportOperators: string[]
  opLabel: Record<string, string>
  isCombined: boolean
  labelPath: string
  isArray: boolean
  isTime: boolean
  isDuration: boolean
}

export const offlineOptionList: OptionConfig[] = [
  {
    label: 'cid',
    value: 'cid',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '客户名称',
    value: 'customerName',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '主叫号码',
    value: 'callNumber',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '被叫号码',
    value: 'phone',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '外呼类型',
    value: 'callType',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  // {
  //   label: '通话结果',
  //   value: 'callResult',
  //   supportOperators: [
  //     'eq',
  //   ],
  //   opLabel: {
  //     'eq': '等于',
  //   },
  //   isCombined: false,
  //   labelPath: 'children',
  //   isArray: false,
  //   isTime: false,
  //   isDuration: false,
  // },
  {
    label: '通话开始时间',
    value: 'callBeginTime',
    supportOperators: [
      'range',
    ],
    opLabel: {
      'range': '范围',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: true,
    isDuration: false,
  },
  {
    label: '通话时长',
    value: 'duration',
    supportOperators: [
      'range',
      'ge',
      'le',
    ],
    opLabel: {
      'range': '范围',
      'ge': '大于等于',
      'le': '小于等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: true,
  },
  {
    label: '关键词匹配状态',
    value: 'matchKeywordStatus',
    supportOperators: [
      'eq',
      'ne',
    ],
    opLabel: {
      'eq': '等于',
      'ne': '不等于',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '客服关键词',
    value: 'saleKeyWord',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: true,
    isTime: false,
    isDuration: false,
  },
  {
    label: '客户关键词',
    value: 'customerKeyWord',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: true,
    isTime: false,
    isDuration: false,
  },
  {
    label: '跟进人',
    value: 'salesName',
    supportOperators: [
      'in',
      'like',
    ],
    opLabel: {
      'in': '包含',
      'like': '模糊匹配',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '所属公司',
    value: 'companyId',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: 'children',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '所属组',
    value: 'groupId',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: 'children',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '人工质检状态',
    value: 'qualityCheckStatus',
    supportOperators: [
      'eq',
      'ne',
    ],
    opLabel: {
      'eq': '等于',
      'ne': '不等于',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '人工质检时间',
    value: 'manualQCTime',
    supportOperators: [
      'range',
    ],
    opLabel: {
      'range': '范围',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: true,
    isDuration: false,
  },
  {
    label: '质检人',
    value: 'qualityCheckSalesName',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '质检人所属组',
    value: 'manualQCSalesGroupId',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: 'children',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '人工评分',
    value: 'qualityCheckScore',
    supportOperators: [
      'eq',
      'gt',
      'ge',
      'lt',
      'le',
    ],
    opLabel: {
      'eq': '等于',
      'gt': '大于',
      'ge': '大于等于',
      'lt': '小于',
      'le': '小于等于',
    },
    isCombined: true,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: 'AI质检状态',
    value: 'aiQCStatus',
    supportOperators: [
      'eq',
      'ne',
    ],
    opLabel: {
      'eq': '等于',
      'ne': '不等于',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: 'AI质检时间',
    value: 'aiQCTime',
    supportOperators: [
      'range',
    ],
    opLabel: {
      'range': '范围',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: true,
    isDuration: false,
  },
  {
    label: '质检方案',
    value: 'aiQCPlanId',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  // {
  //   label: '申诉状态',
  //   value: 'appealStatus',
  //   supportOperators: [
  //     'eq',
  //     'ne',
  //   ],
  //   opLabel: {
  //     'eq': '等于',
  //     'ne': '不等于',
  //   },
  //   isCombined: false,
  //   labelPath: 'label',
  //   isArray: false,
  //   isTime: false,
  //   isDuration: false,
  // },
  {
    label: 'AI检出违规数',
    value: 'aiQCHitRules',
    supportOperators: [
      'eq',
      'gt',
      'ge',
      'lt',
      'le',
    ],
    opLabel: {
      'eq': '等于',
      'gt': '大于',
      'ge': '大于等于',
      'lt': '小于',
      'le': '小于等于',
    },
    isCombined: true,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: 'AI评分',
    value: 'aiQCScore',
    supportOperators: [
      'eq',
      'gt',
      'ge',
      'lt',
      'le',
    ],
    opLabel: {
      'eq': '等于',
      'gt': '大于',
      'ge': '大于等于',
      'lt': '小于',
      'le': '小于等于',
    },
    isCombined: true,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
]

export const onlineOptionList: OptionConfig[] = [
  {
    label: 'cid',
    value: 'cid',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '客户名称',
    value: 'customerName',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '主叫号码',
    value: 'callNumber',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '被叫号码',
    value: 'phone',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '外呼类型',
    value: 'callType',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  // {
  //   label: '通话结果',
  //   value: 'callResult',
  //   supportOperators: [
  //     'eq',
  //   ],
  //   opLabel: {
  //     'eq': '等于',
  //   },
  //   isCombined: false,
  //   labelPath: 'children',
  //   isArray: false,
  //   isTime: false,
  //   isDuration: false,
  // },
  {
    label: '通话时长',
    value: 'duration',
    supportOperators: [
      'range',
      'ge',
      'le',
    ],
    opLabel: {
      'range': '范围',
      'ge': '大于等于',
      'le': '小于等于',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: true,
  },
  {
    label: '关键词匹配状态',
    value: 'matchKeywordStatus',
    supportOperators: [
      'eq',
      'ne',
    ],
    opLabel: {
      'eq': '等于',
      'ne': '不等于',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '客服关键词',
    value: 'saleKeyWord',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: true,
    isTime: false,
    isDuration: false,
  },
  {
    label: '客户关键词',
    value: 'customerKeyWord',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: 'label',
    isArray: true,
    isTime: false,
    isDuration: false,
  },
  {
    label: '跟进人',
    value: 'salesName',
    supportOperators: [
      'in',
      'like',
    ],
    opLabel: {
      'in': '包含',
      'like': '模糊匹配',
    },
    isCombined: false,
    labelPath: '',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '所属公司',
    value: 'companyId',
    supportOperators: [
      'eq',
    ],
    opLabel: {
      'eq': '等于',
    },
    isCombined: false,
    labelPath: 'children',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
  {
    label: '所属组',
    value: 'groupId',
    supportOperators: [
      'in',
    ],
    opLabel: {
      'in': '包含',
    },
    isCombined: false,
    labelPath: 'children',
    isArray: false,
    isTime: false,
    isDuration: false,
  },
]
